// extracted by mini-css-extract-plugin
module.exports = {"root":"UserManagement_root__2-ATP","error":"UserManagement_error__1Mg-b","success":"UserManagement_success__WQFMF","inputs":"UserManagement_inputs__3YN5u"};